import './assets/main.css'
import { createApp } from 'vue'

// Pinia
import { createPinia } from 'pinia'

// Components
import App from './App.vue'

const app = createApp(App)

app.use(createPinia())

app.mount('.jellybeans')
